export default __webpack_public_path__ + "static/media/digitalomega_cropped.ee1aecf8.png";